import type { Meta, StoryFn } from '@storybook/react';
import { useState, useEffect } from 'react';

import { OrderedList } from '@pega/cosmos-react-core';
import type { OrderedListProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/List',
  component: OrderedList
} as Meta;

interface OrderedListStoryProps {
  itemsToShow: number;
  heading: OrderedListProps['heading'];
}

export const OrderedListDemo: StoryFn<OrderedListStoryProps> = (args: OrderedListStoryProps) => {
  const [limit, setLimit] = useState(0);
  const items = [
    'Value 1',
    ['Value 2', 'Value 3', 'Value 4', ['Value 5', 'Value 6', 'Value 7', 'Value 8']],
    'Value 9',
    'Value 10',
    'Value 11',
    'Value 12'
  ];

  useEffect(() => {
    setLimit(args.itemsToShow);
  }, [args.itemsToShow]);

  const handleToggleShow = () => {
    if (limit === args.itemsToShow) {
      setLimit(items.flat().length);
    } else {
      setLimit(args.itemsToShow);
    }
  };

  return (
    <OrderedList
      onToggleShow={handleToggleShow}
      heading={args.heading}
      items={items.slice(0, limit)}
      count={items.flat().length}
    />
  );
};

OrderedListDemo.args = {
  heading: 'List Heading',
  itemsToShow: 3
};

OrderedListDemo.argTypes = {
  heading: { control: { type: 'text' } },
  itemsToShow: { control: { type: 'number' } }
};
